import * as dayjs from 'dayjs';

export function transformRawDataToDocumentsHistoryTableFormat(rawArray) {
  const transformedArray = [];
  rawArray.forEach((element) => {
    const payload = JSON.parse(element.payload);
    transformedArray.push({
      date: dayjs(new Date(element.created)).format('DD.MM.YYYY HH:mm'),
      file_name: payload.filename ? fileNameObject(payload.filename) : null,
      full_path: payload.filename,
      storage_key: payload.storage_key,
      changed_by: element.changed_by,
      imgSrc: '',
      numPages: null,
      showErrorAlert: false,
    });
  });
  return transformedArray;
}

export function resolveDocumentStorageKey(orderId, document) {
  return document.storage_key || `${orderId}/${document.full_path}`;
}

function fileNameObject(filename) {
  let parsedFileName = '';
  const lastIndex = filename.lastIndexOf('/');
  parsedFileName = filename.substring(lastIndex + 1);
  return parsedFileName;
}
